import { Card } from "../../Common/Card";
import Layout from "../../Common/Layout";
import Spacer from "../../Common/Spacer";
import ButtonDemoCard from "./ButtonDemoCard";
import InputDemoCard from "./InputDemoCard";
import SelectDemoCard from "./SelectDemoCard";

const Demo = () => {
	return (
		<Spacer padding="1em">
			<Layout vertical gap="1em">
				<InputDemoCard />
				<SelectDemoCard />
				<ButtonDemoCard />
				<Layout responsive horizontal childrenGrow gap="20px">
					<Card variant="success" title="Card test">
						Testing out a card.
					</Card>
					<Card variant="info" title="Card test">
						Testing out a card.
					</Card>
				</Layout>
				<Card variant="warning" title="Card test">
					Testing out a card.
				</Card>
				<Card variant="danger" title="Card test">
					Testing out a card.
				</Card>
				<Layout responsive horizontal childrenGrow gap="1em">
					<Card title="Card test">Testing out a card. First!!</Card>
					<Card>Testing out a card no title.</Card>
					<Card>Testing out a card no title.</Card>
					<Layout vertical gap="1em">
						<Card>Testing out a card no title.</Card>
						<Card title="Card test">Testing out a card.</Card>
						<Card title="Card test">Testing out a card.</Card>
					</Layout>
				</Layout>
				<Card title="Card test">Testing out a card. Last Card!</Card>
			</Layout>
		</Spacer>
	);
};

export default Demo;
